import React, { memo } from 'react';
import { ZapIcon, BatteryFullIcon, ShieldIcon, UserIcon, LockIcon, RepeatIcon, DumbbellIcon, BookOpenIcon, TrendingUpIcon } from 'lucide-react';
const BenefitsSection = () => {
  const benefits = [{
    icon: <ZapIcon className="w-5 h-5" data-id="element-123" />,
    title: 'Faster Decision-Making',
    description: 'Sharper cognitive processing for quicker, more accurate decisions'
  }, {
    icon: <BatteryFullIcon className="w-5 h-5" data-id="element-124" />,
    title: 'No Energy Crashes',
    description: 'Sustained energy throughout the day without mid-afternoon slumps'
  }, {
    icon: <ShieldIcon className="w-5 h-5" data-id="element-125" />,
    title: 'Enhanced Stress Resilience',
    description: 'Better equipped to handle high-pressure situations with clarity'
  }, {
    icon: <UserIcon className="w-5 h-5" data-id="element-126" />,
    title: 'Improved Executive Presence',
    description: 'Project confidence and authority in every interaction'
  }, {
    icon: <LockIcon className="w-5 h-5" data-id="element-127" />,
    title: 'Zero Dependency',
    description: 'Non-habit forming formula keeps you in control of your sleep'
  }, {
    icon: <RepeatIcon className="w-5 h-5" data-id="element-128" />,
    title: 'Predictable Recovery',
    description: 'Consistent sleep quality for reliable performance'
  }, {
    icon: <DumbbellIcon className="w-5 h-5" data-id="element-129" />,
    title: 'Maintained Physical Performance',
    description: 'Optimize workout recovery and physical endurance'
  }, {
    icon: <BookOpenIcon className="w-5 h-5" data-id="element-130" />,
    title: 'Enhanced Learning & Retention',
    description: 'Improved memory consolidation for better information retention'
  }, {
    icon: <TrendingUpIcon className="w-5 h-5" data-id="element-131" />,
    title: 'Competitive Advantage',
    description: 'Outperform competitors through consistent peak performance'
  }];
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-132">
      <div className="container mx-auto px-4" data-id="element-133">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-134">
          Performance Benefits
        </h2>
        <p className="text-lg md:text-xl text-gray-700 text-center max-w-3xl mx-auto mb-16" data-id="element-135">
          NightPhase doesn't just improve your sleep—it enhances your entire
          professional performance.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-136">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md flex" data-id="element-137">
              <div className="mr-3 bg-indigo-100 p-2 rounded-full text-indigo-800 flex-shrink-0 flex items-center justify-center h-8 w-8" data-id="element-138">
                {benefit.icon}
              </div>
              <div data-id="element-139">
                <h3 className="text-lg font-semibold mb-2" data-id="element-140">{benefit.title}</h3>
                <p className="text-gray-600" data-id="element-141">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default BenefitsSection;